import { useState } from "react";
import { slice } from "lodash";

export default function useSlices<T>(data: T[], sliceSize = 10) {
  const [page, setPage] = useState(1);

  return {
    slicedData: slice(data, 0, page * sliceSize),
    loadSlice: () => setPage((p) => p + 1),
    waypointPosition: sliceSize * page - 2,
  };
}
